import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbPopoverModule,
  NbProgressBarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbTooltipModule,
} from '@nebular/theme';
import { ThemeModule } from '../../@theme/theme.module';
import { IscanCommmonModule } from '../../common/common.module';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';

const COMPONENTS = [LoginComponent, LogoutComponent];

const MODULES = [
  NbCardModule,
  NbAlertModule,
  NbInputModule,
  NbCheckboxModule,
  NbIconModule,
  NbButtonModule,
  NbSpinnerModule,
  IscanCommmonModule,

  RouterModule,
  FormsModule,
  ThemeModule,

  NbFormFieldModule,
  NbIconModule,
  NbButtonModule,
  NbTooltipModule,
  FormsModule,
  NbToastrModule,
  NbPopoverModule,
  NbSpinnerModule,
  NbDialogModule.forChild(),
  NbProgressBarModule,
];

@NgModule({
  imports: [CommonModule, ...MODULES],
  declarations: [...COMPONENTS],
  exports: [CommonModule, ...COMPONENTS],
  entryComponents: [...COMPONENTS]
})
export class LoginModule {}
